module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 0
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Agreements")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 2
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Archived")])])]), _vm._v(" "), (_vm.tab === 0) ? _c('makeagreement', {
    on: {
      "new": _vm.addAgreement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab > 0) ? _c('div', {
    staticClass: "dataTable"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns dataTableHeader"
  }, [_c('div', {
    staticClass: "col-3 col-md-6"
  }, [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-md-5"
  }, [_vm._v("\n          Type\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          Sent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          Accepted\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-xs text-center"
  }, [_vm._v("\n          Send\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-xs text-center"
  }, [_vm._v("\n          PDF\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-xs text-center"
  }, [_vm._v("\n          Download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.tab === 1 ? 'Archive' : 'Unarchive') + "\n        ")]), _vm._v(" "), (_vm.tab === 2) ? _c('div', {
    staticClass: "col-1 hide-md text-center"
  }, [_vm._v("\n          Delete\n        ")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.filtered), function(a, n) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "col-3 col-md-6"
    }, [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.viewPdf(a, 'inline')
        }
      }
    }, [_vm._v(_vm._s(a.corporate ? a.business : a.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 col-md-5"
    }, [_c('span', [_vm._v(_vm._s(a.visatype))])]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('i', {
      staticClass: "icon",
      class: a.sent ? 'icon-check' : 'icon-cross'
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('i', {
      staticClass: "icon",
      class: a.accepted ? 'icon-check' : 'icon-cross'
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-xs text-center"
    }, [_c('button', {
      staticClass: "btn",
      class: {
        loading: _vm.sending === a._id
      },
      on: {
        "click": function($event) {
          return _vm.openSendModal(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-send-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-xs text-center"
    }, [(a.pdf) ? _c('button', {
      staticClass: "btn btn-sm",
      class: {
        loading: _vm.makingPdf === a._id
      },
      on: {
        "click": function($event) {
          return _vm.makePdf(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-repeat",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-xs text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.viewPdf(a, 'attachment')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.archive(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-archive-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), (_vm.tab === 2) ? _c('div', {
      staticClass: "col-1 hide-md text-center"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.del(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('sendModal', {
    attrs: {
      "show": _vm.showSendModal,
      "agreement": _vm.toSend,
      "invoice": null
    },
    on: {
      "close": _vm.closeSendModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c6707a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreements/agreements.vue
// module id = 486
// module chunks = 1